import React from 'react';
import { RelayMigrationProvider } from '@atlassian/jira-relay-apollo-migration-utils/src/services/use-query/index.tsx';
import CycleTimeDataAnalyticsWrapper from './ui/cycletime-data-analytics-wrapper/index.tsx';
import CycleTimeBreakdown from './ui/index.tsx';

type CycleTimeReportPageProps = {
	hasProviders: boolean;
};

const CycleTimeReportPage = ({ hasProviders }: CycleTimeReportPageProps) => (
	<RelayMigrationProvider>
		<CycleTimeDataAnalyticsWrapper hasProviders={hasProviders}>
			<CycleTimeBreakdown hasProviders={hasProviders} />
		</CycleTimeDataAnalyticsWrapper>
	</RelayMigrationProvider>
);

export default CycleTimeReportPage;
